export default "__VITE_ASSET__Cz7z7WYn__"